import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import { ComplexSuggestedItem } from '../../../ui/gzComplexEnumList/types';
import { WEB_COMPONENT_EASM_ARTIFACTS_INVENTORY_GRID } from '../../../webcomponents.constants';
import { EasmArtifactsInventoryGridWebComponent } from '../component/EasmArtifactsInventoryGridWebComponent';

export class EasmArtifactsInventoryCVEProvider {
  /**
   *
   * @param page
   * @param limit
   * @param searchString
   * @param filters
   * @protected
   */
  static async getRemoteData(page, limit, searchString: string = '', filters: Array<any> = []): Promise<Array<any>> {
    const result = await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'EASMFindings',
      method: 'getAvailableArtifactsCves',
      payload: {
        page,
        limit,
        cveString: searchString,
        companyId: filters[0],
      },
    });

    return result.data;
  }

  /**
   *
   * @param response
   * @protected
   */
  static convertResponse(response: Array<string>): ComplexSuggestedItem[] {
    return response.map((item: string) => {
      return {
        label: item,
        value: item,
      };
    });
  }

  static getExtraFilters(): Array<any> {
    const grid = document.querySelector(
      WEB_COMPONENT_EASM_ARTIFACTS_INVENTORY_GRID
    ) as EasmArtifactsInventoryGridWebComponent;

    if (!grid) {
      return [];
    }
    return [grid.getCompanyIdFilterValue()];
  }
}
